function toggleMoreInfo(kc) {
  /* var boxPar = kc.parentElement.parentElement;
    if (boxPar.getElementsByClassName('cabinetsOpt')[0].checked == true || boxPar.getElementsByClassName('counterOpt')[0].checked == true || boxPar.getElementsByClassName('floorOpt')[0].checked == true){
        boxPar.parentElement.parentElement.getElementsByClassName('allInfo')[0].classList.add('showInfo');   
    }else{
        boxPar.parentElement.parentElement.getElementsByClassName('allInfo')[0].classList.remove('showInfo');
    }
    */
}

function toggleCatalogAddress(kc, er) {
  kc.parentElement.parentElement.parentElement.parentElement.getElementsByClassName(
    "etcPrintCatFields",
  )[0].style.display = er;
}

function validateEmail(e) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e);
}

//ETC's valifate 5 0r 9 digit zip
// function validateZip(z) {
//   return /^[0-9]{5}(?:-[0-9]{4})?$/.test(z);
// }

function validateZip(z) {
  return /^[0-9]{5}$/.test(z);
}

async function botCheck(form) {
  let stopBotCat = form["job-name"].value;
  if (stopBotCat != null && stopBotCat != "") {
    let formData = new FormData();
    let formElements = form.elements;
    for (let i = 0; i < formElements.length; i++) {
      let element = formElements[i];
      let name = element.name;
      let value = element.value;
      formData.append(name, value);
    }
    console.log("bot detected");
    let formLeadSource = document.querySelector(".formSource").value;
    if (
      !formData.get("leadsource") ||
      formData.get("leadsource").trim() === ""
    ) {
      formData.set("leadsource", formLeadSource);
    }
    $.ajax({
      url: "https://formscabinetstogo.com/bot_form.php",
      method: "POST",
      data: formData,
      processData: false,
      contentType: false,
      success: function (response) {
        console.log("Bot data processed successfully");
      },
      error: function (xhr, status, error) {
        console.log("Error processing bot data: ", error);
      },
    });
    return false;
  } else {
    let formCheck = etcStoreValidate(form);
    return formCheck;
  }
}

function botCheckHammer(form) {
  let stopBotHammer = form["job-title"].value;
  if (stopBotHammer != null && stopBotHammer != "") {
    console.log("bot detected");
    let formData = new FormData();
    let formElements = form.elements;
    for (let i = 0; i < formElements.length; i++) {
      let element = formElements[i];
      let name = element.name;
      let value = element.value;
      formData.append(name, value);
    }
    let formLeadSource = document.querySelector(".formSource").value;
    if (
      !formData.get("leadsource") ||
      formData.get("leadsource").trim() === ""
    ) {
      formData.set("leadsource", formLeadSource);
    }
    $.ajax({
      url: "https://formscabinetstogo.com/bot_form.php",
      method: "POST",
      data: formData,
      processData: false,
      contentType: false,
      success: function (response) {
        console.log("Bot data processed successfully");
      },
      error: function (xhr, status, error) {
        console.log("Error processing bot data: ", error);
      },
    });
    return false;
  } else {
    etcStoreValidate(form);
  }
}

// Simple validation function for newsletter form
function validateNewsletterForm(form) {
  const email = form.querySelector('input[name="email"]').value.trim();
  const zipcode = form.querySelector('input[name="zipcode"]').value.trim();
  const honeypot = form.querySelector("#gotchaBot").value;
  const loadTime = form.querySelector("#formLoadTime").value;
  const submitTime = Date.now();
  const timeDiff = submitTime - loadTime;

  // Check honeypot
  if (honeypot !== "") {
    console.log("Bot detected (honeypot filled)");
    return false;
  }

  // Check if submitted too fast
  if (timeDiff < 3000) {
    console.log("Bot detected (too fast)");
    return false;
  }

  // Validate email
  let isValidEmail =/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  if (!email || !isValidEmail) {
    alert("Please enter a valid email address.");
    form.querySelector('input[name="email"]').classList.add("failed");
    return false;
  }

  // Validate zip code
  let isValidZip = /^[0-9]{5}(?:-[0-9]{4})?$/.test(zipcode);
  if (!zipcode || !isValidZip) {
    alert("Please enter a valid 5-digit zip code.");
    form.querySelector('input[name="zipcode"]').classList.add("failed");
    return false;
  }

  return true;
}

function etcStoreValidate(xf) {
  var vFirst = xf["firstname"];
  var vLast = xf["lastname"];
  var vPhone = xf["phone"];
  var vEmail = xf["email"];
  var vZip = xf["zipcode"];
  var vCity = xf["city"];
  var vAddress = xf["address1"];
  var vState = xf["state"];
  var vCatalog = xf["custentity_ctg_web_catalog_type"];
  var vCompany = xf["companyname"];
  var vHeard = xf["custentity18"];
  if (xf["valPhoneNum"]) {
    var valPhoneNum = xf["valPhoneNum"].value == "true";
  }

  var fails = 0;
  var failMessage = "Please correct all highlighted fields.";

  urlFormatting(xf);

  if (vFirst != null) {
    if (vFirst.value == "") {
      fails = fails + 1;
      vFirst.classList.add("failed");
    } else {
      vFirst.classList.remove("failed");
    }
  }
  if (vLast != null) {
    if (vLast.value == "") {
      fails = fails + 1;
      vLast.classList.add("failed");
    } else {
      vLast.classList.remove("failed");
    }
  }
  if (vPhone != null) {
    if (vPhone.value == "") {
      if (!valPhoneNum) {
        vPhone.classList.remove("failed");
      } else {
        fails = fails + 1;
        vPhone.classList.add("failed");
      }
    } else {
      console.log("silver");
      vPhone.classList.remove("failed");
    }
  }
  if (vEmail != null) {
    if (vEmail.value == "") {
      fails = fails + 1;
      vEmail.classList.add("failed");
    } else {
      if (validateEmail(vEmail.value)) {
        vEmail.classList.remove("failed");
      } else {
        fails = fails + 1;
        failMessage = failMessage + "<br>Please enter a valid email address.";
        vEmail.classList.add("failed");
      }
    }
  }

  if (vCatalog == null) {
    if (vAddress != null) {
      if (vAddress.value == "") {
        fails = fails + 1;
        vAddress.classList.add("failed");
        console.log("Address failed");
      } else {
        vAddress.classList.remove("failed");
      }
    }
  }

  if (vState != null) {
    if (vState.value == "") {
      fails = fails + 1;
      vState.classList.add("failed");
    } else {
      vState.classList.remove("failed");
    }
  }
  if (vZip != null) {
    if (vZip.value == "") {
      fails = fails + 1;
      vZip.classList.add("failed");
    } else {
      if (validateZip(vZip.value)) {
        vZip.classList.remove("failed");
      } else {
        fails = fails + 1;
        failMessage =
          failMessage + "<br>Please enter a valid 5 digit US zip code.";
        vZip.classList.add("failed");
      }
    }
  }

  if (vCatalog != null) {
    if (vCatalog.value != "Digital") {
      if (vCity.value == "") {
        fails = fails + 1;
        vCity.classList.add("failed");
      } else {
        vCity.classList.remove("failed");
      }
      if (vAddress.value == "") {
        fails = fails + 1;
        vAddress.classList.add("failed");
      } else {
        vAddress.classList.remove("failed");
      }
    }
  } else {
    if (vCity != null) {
      if (vCity.value == "") {
        fails = fails + 1;
        vCity.classList.add("failed");
      } else {
        vCity.classList.remove("failed");
      }
    }
  }

  if (vHeard != null) {
    if (vHeard.value == 0) {
      fails = fails + 1;
      vHeard.classList.add("failed");
      failMessage = failMessage + "<br>Please select how you heard about us.";
    } else {
      vHeard.classList.remove("failed");
    }
  }

  if (xf["name"].value == null || xf["name"].value == "") {
    // console.log("works");

    if (fails > 0) {
      xf.getElementsByClassName("etcFormMessage")[0].innerHTML = failMessage;
      xf.getElementsByClassName("etcFormMessage")[0].style.color = "#fa725b";
      if (xf.querySelector(".etcBottomFormMessage") !== null) {
        xf.getElementsByClassName("etcBottomFormMessage")[0].innerHTML =
          failMessage;
        xf.getElementsByClassName("etcBottomFormMessage")[0].style.color =
          "#fa725b";
      }

      return false;
    } else {
      if (xf["companyname"] != null) {
        if (xf["companyname"].value == "newsletter signup") {
          xf.parentElement
            .getElementsByClassName("formLoadingFrame")[0]
            .classList.add("newsformLoading");
          // fixIframe();
          xf.classList.add("newsformLoading");
        } else {
          xf.parentElement
            .getElementsByClassName("formLoadingFrame")[0]
            .classList.add("formLoading");
          xf.classList.add("formLoading");
        }
      } else {
        xf.parentElement
          .getElementsByClassName("formLoadingFrame")[0]
          .classList.add("formLoading");
        xf.classList.add("formLoading");
      }
      var bsubscribed = xf.getElementsByClassName("subscribeBox")[0].checked;
      if (xf.id != "catalog-request-form") {
        var bleadSource = xf.getElementsByClassName("ProOptionValue")[0].value;
      }

      var imgNode = document.createElement("img");
      imgNode.src =
        "https://app.bronto.com/public/?q=direct_add&fn=Public_DirectAddForm&id=bfalreuskjvdieedfscwbhxmdhtabff&email=" +
        vEmail.value +
        "&field1=firstname,set," +
        vFirst.value +
        "&field2=lastname,set," +
        vLast.value +
        "&field3=subscribed,set," +
        bsubscribed +
        "&field4=lead_source,set," +
        bleadSource;
      imgNode.width = 0;
      imgNode.height = 0;
      imgNode.border = 0;
      xf.parentElement.appendChild(imgNode);
      //ga(‘send’, ‘event’, { eventCategory: ‘Contact ‘, eventAction: ‘Submit’, eventLabel: ‘Store Page Form’, eventValue: 1});

      var expNode = document.createElement("img");
      expNode.src =
        "https://insight.adsrvr.org/track/pxl/?adv=9pw32f4&ct=0:rktfvhf&fmt=3";
      expNode.width = 0;
      expNode.height = 0;
      expNode.border = 0;
      xf.parentElement.appendChild(expNode);

      // (function(){var x=null,p,q,m,
      //     o="21102",
      //     l="ORDER ID",
      //     i="TOTAL ORDER AMOUNT",
      //     c="",
      //     k="PRODUCT IDs",
      //     g="PRODUCT QUANTITIES",
      //     j="UNIT PRICES",
      //     u="",
      //     shadditional="";
      //             try{p=top.document.referer!==""?encodeURIComponent(top.document.referrer.substring(0,512)):""}catch(n){p=document.referrer!==null?document.referrer.toString().substring(0,512):""}try{q=window&&window.top&&document.location&&window.top.location===document.location?document.location:window&&window.top&&window.top.location&&""!==window.top.location?window.top.location:document.location}catch(b){q=document.location}try{m=parent.location.href!==""?encodeURIComponent(parent.location.href.toString().substring(0,512)):""}catch(z){try{m=q!==null?encodeURIComponent(q.toString().substring(0,512)):""}catch(h){m=""}}var A,y=document.createElement("script"),w=null,v=document.getElementsByTagName("script"),t=Number(v.length)-1,r=document.getElementsByTagName("script")[t];if(typeof A==="undefined"){A=Math.floor(Math.random()*100000000000000000)}w="dx.steelhousemedia.com/spx?conv=1&shaid="+o+"&tdr="+p+"&plh="+m+"&cb="+A+"&shoid="+l+"&shoamt="+i+"&shocur="+c+"&shopid="+k+"&shoq="+g+"&shoup="+j+"&shpil="+u+shadditional;y.type="text/javascript";y.src=("https:"===document.location.protocol?"https://":"http://")+w;r.parentNode.insertBefore(y,r)}());

      // !(function (f, b, e, v, n, t, s) {
      //   if (f.fbq) return;
      //   n = f.fbq = function () {
      //     n.callMethod
      //       ? n.callMethod.apply(n, arguments)
      //       : n.queue.push(arguments);
      //   };
      //   if (!f._fbq) f._fbq = n;
      //   n.push = n;
      //   n.loaded = !0;
      //   n.version = "2.0";
      //   n.queue = [];
      //   t = b.createElement(e);
      //   t.async = !0;
      //   t.src = v;
      //   s = b.getElementsByTagName(e)[0];
      //   s.parentNode.insertBefore(t, s);
      // })(
      //   window,
      //   document,
      //   "script",
      //   "https://connect.facebook.net/en_US/fbevents.js",
      // );
      // fbq("init", "2099702066803979");
      // fbq("track", "PageView");
      //console.log(xf.parentElement.parentElement.getElementsByClassName('formSource')[0].value);
      if (
        xf.parentElement.parentElement.getElementsByClassName("formSource")[0]
          .value == "CAM02 Online Catalog Request"
      ) {
        fbq("track", "Subscribe");
      } else {
        fbq("track", "Lead");
      }

      if (
        xf.parentElement.parentElement.getElementsByClassName("formSource")[0]
          .value == "CAM02 Online Catalog Request"
      ) {
        (function (w, d) {
          var id = "pdst-capture",
            n = "script";
          if (!d.getElementById(id)) {
            w.pdst =
              w.pdst ||
              function () {
                (w.pdst.q = w.pdst.q || []).push(arguments);
              };
            var e = d.createElement(n);
            e.id = id;
            e.async = 1;
            e.src = "https://cdn.pdst.fm/ping.min.js";
            var s = d.getElementsByTagName(n)[0];
            s.parentNode.insertBefore(e, s);
          }
          w.pdst("conf", { key: "17610d6547e5489094e5712f1277faf7" });
          w.pdst("lead", {
            category: "Form Submission",
            type: "Catalog Request Form", // Dynamically populate from session data
            value: "", // Dynamically populate from session data
            currency: "",
          });
        })(window, document);
      } else if (
        xf.parentElement.parentElement.getElementsByClassName("formSource")[0]
          .value == "CAM04 Quote Request"
      ) {
        (function (w, d) {
          var id = "pdst-capture",
            n = "script";
          if (!d.getElementById(id)) {
            w.pdst =
              w.pdst ||
              function () {
                (w.pdst.q = w.pdst.q || []).push(arguments);
              };
            var e = d.createElement(n);
            e.id = id;
            e.async = 1;
            e.src = "https://cdn.pdst.fm/ping.min.js";
            var s = d.getElementsByTagName(n)[0];
            s.parentNode.insertBefore(e, s);
          }
          w.pdst("conf", { key: "17610d6547e5489094e5712f1277faf7" });
          w.pdst("lead", {
            category: "Form Submission",
            type: "Quote Request Form", // Dynamically populate from session data
            value: "", // Dynamically populate from session data
            currency: "",
          });
        })(window, document);
      } else if (
        xf.parentElement.parentElement.getElementsByClassName("formSource")[0]
          .value == "CAM05 Design Consultation"
      ) {
        (function (w, d) {
          var id = "pdst-capture",
            n = "script";
          if (!d.getElementById(id)) {
            w.pdst =
              w.pdst ||
              function () {
                (w.pdst.q = w.pdst.q || []).push(arguments);
              };
            var e = d.createElement(n);
            e.id = id;
            e.async = 1;
            e.src = "https://cdn.pdst.fm/ping.min.js";
            var s = d.getElementsByTagName(n)[0];
            s.parentNode.insertBefore(e, s);
          }
          w.pdst("conf", { key: "17610d6547e5489094e5712f1277faf7" });
          w.pdst("lead", {
            category: "Form Submission",
            type: "Design Consultation Form", // Dynamically populate from session data
            value: "", // Dynamically populate from session data
            currency: "",
          });
        })(window, document);
      } else if (
        xf.parentElement.parentElement.getElementsByClassName("formSource")[0]
          .value == "CAM26 Servpro"
      ) {
        (function (w, d) {
          var id = "pdst-capture",
            n = "script";
          if (!d.getElementById(id)) {
            w.pdst =
              w.pdst ||
              function () {
                (w.pdst.q = w.pdst.q || []).push(arguments);
              };
            var e = d.createElement(n);
            e.id = id;
            e.async = 1;
            e.src = "https://cdn.pdst.fm/ping.min.js";
            var s = d.getElementsByTagName(n)[0];
            s.parentNode.insertBefore(e, s);
          }
          w.pdst("conf", { key: "17610d6547e5489094e5712f1277faf7" });
          w.pdst("lead", {
            category: "Form Submission",
            type: "Design Consultation Form", // Dynamically populate from session data
            value: "", // Dynamically populate from session data
            currency: "",
          });
        })(window, document);
      } else {
      }
      return true;
    }
  } else {
    console.log("error");
    return false;
  }
}

function fixIframe() {
  const myIframe = document.getElementsByName("footerNewsLoadingFrame")[0];
  const myBody = myIframe.contentWindow.document.body;
  const newElement = document.createElement("h4");
  newElement.innerHTML = "Thank you for subscribing!";
  myBody.appendChild(newElement);
  newElement.style.color = "#60285f";
  newElement.style.marginTop = "35px";
  newElement.style.textAlign = "center";
  // console.log(myIframe);
}

function urlFormatting(xf) {
  //check if subscribed or not and place value
  if (xf.getElementsByClassName("subscribeBox")[0] != null) {
    if (xf.getElementsByClassName("subscribeBox")[0].checked == false) {
      xf.getElementsByClassName("subscribeBox")[0].type = "hidden";
      xf.getElementsByClassName("subscribeBox")[0].value = "F";
    }
  }
  //check if pro or not and place value
  if (xf.getElementsByClassName("ProOption")[0] != null) {
    if (xf.getElementsByClassName("ProOption")[0].checked == true) {
      xf.getElementsByClassName("ProOptionValue")[0].value = "CAM19 Pro Lead";
    } else {
      xf.getElementsByClassName("ProOptionValue")[0].value =
        xf.parentElement.parentElement.getElementsByClassName(
          "formSource",
        )[0].value;
    }
  }
  //check what project they selected and place value
  if (xf.getElementsByClassName("projectValue")[0] != null) {
    var projectValue = xf.getElementsByClassName("projectValue")[0];
    var kitchenOpt = xf.getElementsByClassName("kitchenOpt")[0];
    var bathOpt = xf.getElementsByClassName("bathOpt")[0];
    var closetOpt = xf.getElementsByClassName("closetOpt")[0];
    var otherOpt = xf.getElementsByClassName("otherOpt")[0];

    if (kitchenOpt.checked == true) {
      if (bathOpt.checked == true) {
        if (closetOpt.checked == true) {
          if (otherOpt.checked == true) {
            projectValue.value =
              kitchenOpt.value +
              ", " +
              bathOpt.value +
              ", " +
              closetOpt.value +
              ", " +
              otherOpt.value;
          } else {
            projectValue.value =
              kitchenOpt.value + ", " + bathOpt.value + ", " + closetOpt.value;
          }
        } else if (otherOpt.checked == true) {
          projectValue.value =
            kitchenOpt.value + ", " + bathOpt.value + ", " + otherOpt.value;
        } else {
          projectValue.value = kitchenOpt.value + ", " + bathOpt.value;
        }
      } else if (closetOpt.checked == true) {
        if (otherOpt.checked == true) {
          projectValue.value =
            kitchenOpt.value + ", " + closetOpt.value + ", " + otherOpt.value;
        } else {
          projectValue.value = kitchenOpt.value + ", " + closetOpt.value;
        }
      } else if (otherOpt.checked == true) {
        projectValue.value = kitchenOpt.value + ", " + otherOpt.value;
      } else {
        projectValue.value = kitchenOpt.value;
      }
    } else if (bathOpt.checked == true) {
      if (closetOpt.checked == true) {
        if (otherOpt.checked == true) {
          projectValue.value =
            bathOpt.value + ", " + closetOpt.value + ", " + otherOpt.value;
        } else {
          projectValue.value = bathOpt.value + ", " + closetOpt.value;
        }
      } else if (otherOpt.checked == true) {
        projectValue.value = bathOpt.value + ", " + otherOpt.value;
      } else {
        projectValue.value = bathOpt.value;
      }
    } else if (closetOpt.checked == true) {
      if (otherOpt.checked == true) {
        projectValue.value = closetOpt.value + ", " + otherOpt.value;
      } else {
        projectValue.value = closetOpt.value;
      }
    } else if (otherOpt.checked == true) {
      projectValue.value = otherOpt.value;
    } else {
      projectValue.value = "Not Specified";
    }
  }
  //check what product interests they selected and place value
  // if (xf.getElementsByClassName('interestedValue')[0] != null){
  //   var interestedValue = xf.getElementsByClassName('interestedValue')[0];
  //   var cabinetsOpt = xf.getElementsByClassName('cabinetsOpt')[0];
  //   var counterOpt = xf.getElementsByClassName('counterOpt')[0];
  //   var floorOpt = xf.getElementsByClassName('floorOpt')[0];

  //   if (cabinetsOpt.checked == true){
  //     if (counterOpt.checked == true){
  //       if (floorOpt.checked == true){
  //         interestedValue.value = cabinetsOpt.value+", "+floorOpt.value+" and "+counterOpt.value;
  //       }else{
  //         interestedValue.value = cabinetsOpt.value+" and "+counterOpt.value;
  //       }
  //     }else if(floorOpt.checked == true){
  //       interestedValue.value = cabinetsOpt.value+" and "+floorOpt.value;
  //     }else{
  //       interestedValue.value = cabinetsOpt.value+" Only";
  //     }
  //   }else if(counterOpt.checked == true){
  //     if (floorOpt.checked == true){
  //       interestedValue.value = counterOpt.value+" and "+floorOpt.value;
  //     }else{
  //       interestedValue.value = counterOpt.value+" Only";
  //     }
  //   }else if(floorOpt.checked == true){
  //     interestedValue.value = floorOpt.value+" Only";
  //   }
  // }

  if (xf.getElementsByClassName("interestedValue")[0] != null) {
    var interestedValue = xf.getElementsByClassName("interestedValue")[0];
    var cabinetsOpt = xf.getElementsByClassName("cabinetsOpt")[0];
    var counterOpt = xf.getElementsByClassName("counterOpt")[0];

    if (cabinetsOpt.checked == true) {
      if (counterOpt.checked == true) {
        interestedValue.value = cabinetsOpt.value + " and " + counterOpt.value;
      } else {
        interestedValue.value = cabinetsOpt.value + " Only";
      }
    } else if (counterOpt.checked == true) {
      interestedValue.value = counterOpt.value + " Only";
    }
  }
  //check what areas make up their project and whatnot
  if (xf.getElementsByClassName("projectMakeup")[0] != null) {
    var projectMakeup = xf.getElementsByClassName("projectMakeup")[0];
    var projClosetsOpt = xf.getElementsByClassName("projClosetsOpt")[0];
    var projCabinetOpt = xf.getElementsByClassName("projCabinetOpt")[0];
    var projKitchenOpt = xf.getElementsByClassName("projKitchenOpt")[0];
    var projBathOpt = xf.getElementsByClassName("projBathOpt")[0];
    var projFlooringOpt = xf.getElementsByClassName("projFlooringOpt")[0];
    var projOtherOpt = xf.getElementsByClassName("projOtherOpt")[0];
    var ffProjects = "";

    if (projClosetsOpt.checked == true) {
      ffProjects = ffProjects + projClosetsOpt.value + ", ";
    }
    if (projCabinetOpt.checked == true) {
      ffProjects = ffProjects + projCabinetOpt.value + ", ";
    }
    if (projKitchenOpt.checked == true) {
      ffProjects = ffProjects + projKitchenOpt.value + ", ";
    }
    if (projBathOpt.checked == true) {
      ffProjects = ffProjects + projBathOpt.value + ", ";
    }
    if (projFlooringOpt.checked == true) {
      ffProjects = ffProjects + projFlooringOpt.value + ", ";
    }
    if (projOtherOpt.checked == true) {
      ffProjects = ffProjects + projOtherOpt.value + ", ";
    }

    projectMakeup.value = ffProjects;
  }
  //check if this is the custom built form and append all sample data to #builtSamplesArea using \n for line breaks

  if (xf.getElementsByClassName("builtSamplesArea")[0] != null) {
    var cbSamplesCont = document.getElementById("builtSamplesArea");
    var cbDoorsCont = document.getElementById("doorSampContainer");
    var cbColorsCont = document.getElementById("colorSampContainer");
    var cbSampleRows = document.getElementsByClassName("sampRow");
    var cbOutput = "";

    for (var i = 0; i < cbSampleRows.length; i++) {
      var sampDoorValue = "Color | Material: ";
      if (cbSampleRows[i].getElementsByClassName("cbDoorStyle")[0] != null) {
        sampDoorValue =
          "Door | Name: " +
          cbSampleRows[i].getElementsByClassName("cbDoorStyle")[0].value +
          " | Material: ";
      }
      var matSampleCont =
        cbSampleRows[i].getElementsByClassName("cbMatStyle")[0];
      var sampMatValue = matSampleCont[matSampleCont.selectedIndex].text;
      var sampFinValue =
        cbSampleRows[i].getElementsByClassName("cbFinStyle")[0].value;
      var sampSeriesValue = "historic";
      if (cbSampleRows[i].getElementsByClassName("cbSeries")[0] != null) {
        sampSeriesValue =
          cbSampleRows[i].getElementsByClassName("cbSeries")[0].value;
      }
      cbOutput =
        cbOutput +
        sampDoorValue +
        sampMatValue +
        " | Finish: " +
        sampFinValue +
        " | Series: " +
        sampSeriesValue +
        "\n";
    }

    builtSamplesArea.value = cbOutput;
    document.cookie =
      "sampCount=; expires= Thu, 01 Jan 1970 00:00:00 UTC; Secure; SameSite=Strict";
    document.cookie =
      "doorSamp=; expires= Thu, 01 Jan 1970 00:00:00 UTC; Secure; SameSite=Strict";
    document.cookie =
      "colorSamp=; expires= Thu, 01 Jan 1970 00:00:00 UTC; Secure; SameSite=Strict";
    getCBSBadgeCookies();
  }

  // Check for the best contact method
  if (xf.getElementsByClassName("contactMethod")[0] != null) {
    var contactMethod = xf.getElementsByClassName("contactMethod")[0];
    var phoneOpt = xf.getElementsByClassName("PhoneOpt")[0];
    var textOpt = xf.getElementsByClassName("TextOpt")[0];
    var emailOpt = xf.getElementsByClassName("EmailOpt")[0];

    // Best way to contact customer
    if (phoneOpt.checked == true) {
      if (textOpt.checked == true) {
        if (emailOpt.checked == true) {
          contactMethod.value =
            phoneOpt.value + ", " + textOpt.value + ", " + emailOpt.value;
        } else {
          contactMethod.value = phoneOpt.value + ", " + textOpt.value;
        }
      } else if (emailOpt.checked == true) {
        contactMethod.value = phoneOpt.value + ", " + emailOpt.value;
      } else {
        contactMethod.value = phoneOpt.value;
      }
    } else {
      contactMethod.value = "Not Specified";
    }
  }
}
